import moment from 'moment'
import { isEmpty } from 'lodash'

export const formatDateOrDash = (
    rawValue: string | number | Date | null | undefined,
    dateFormat: string = 'DD/MM/YYYY'
  ): string => {
    if (isEmpty(rawValue)) {
      return '--'
    }

    const MILLISECOND_THRESHOLD = 1e12
    let parsedDate: moment.Moment

    if (typeof rawValue === 'number') {
      parsedDate = rawValue > MILLISECOND_THRESHOLD
        ? moment(rawValue)
        : moment.unix(rawValue)
    } else if (typeof rawValue === 'string') {
      const trimmedValue = rawValue.trim()

      if (trimmedValue === '') {
        return '--'
      }

      const formats = [
        moment.ISO_8601,
        'YYYY-MM-DD',
        'DD-MM-YYYY',
        'DD/MM/YYYY'
      ]

      parsedDate = moment(trimmedValue, formats, true)

      if (!parsedDate.isValid()) {
        parsedDate = moment(trimmedValue)
      }
    } else {
      parsedDate = moment(rawValue)
    }

    return parsedDate.isValid() ? parsedDate.format(dateFormat) : '--'
  }
